module.exports = __webpack_public_path__ + "img/BTS-Lacnor-b.97ca217a.png";